import { AliceSkillName, BobSkillName } from "./alice-bob";

export const mRound = (x: number, multiple: number): number => {
    return Math.round(x / multiple) * multiple;
}

// Enemy config
export const enemyBaseHP = [65, 200, 300, 600, 1200, 2800, 4000, 6000]

export const enemyGrowth = (chapter: number): number => {
    return 1.66 + (-0.09) * chapter;
}

export const enemyBossMulti = (chapter: number): number => {
    return 1 + 0.13 * chapter;
}

export const enemyConfig = (orderNumber: number, chapter: number, isBoss: boolean): { hp: number, reward: number } => {
    const hp = mRound(enemyBaseHP[chapter] * enemyGrowth(chapter) ** (orderNumber - 1.35) * enemyBossMulti(chapter) ** (isBoss ? 1 : 0), 10)
    return { hp, reward: mRound(hp / 2, 5) }
}

// Ability config
export type AbilityConfiguration = {
    initialCost: number;
    earlyMulti: number;
    midMulti: number;
    lateMulti: number;
    initialValue: number;
    increaseRate: number;
}

export type AliceAbilityConfig = Record<AliceSkillName, AbilityConfiguration>
export const aliceConfig: AliceAbilityConfig = {
    damage_level: {
        initialCost: 50,
        earlyMulti: 1.32,
        midMulti: 1.42,
        lateMulti: 1.55,
        initialValue: 4,
        increaseRate: 2
    },
    extra_gold_level: {
        initialCost: 80,
        earlyMulti: 1.6,
        midMulti: 1.5,
        lateMulti: 1.5,
        initialValue: 2,
        increaseRate: 2
    },
    critical_chance_level: {
        initialCost: 120,
        earlyMulti: 1.6,
        midMulti: 1.5,
        lateMulti: 1.5,
        initialValue: 2,
        increaseRate: 1
    },
    aura_level: {
        initialCost: 300,
        earlyMulti: 1.3,
        midMulti: 1.4,
        lateMulti: 1.45,
        initialValue: 2,
        increaseRate: 1
    }
}

export const getMulti = (chapter: number, configuration: AbilityConfiguration): number => {
    if (chapter <= 3) return configuration.earlyMulti;
    else if (chapter > 3 && chapter <= 6) return configuration.midMulti;
    else return configuration.lateMulti;
}

export const getUpgradeSpecAlice = (ability: AliceSkillName, lvl: number, currentChapter: number): { value: number, cost: number } => {
    return {
        value: aliceConfig[ability].initialValue + (aliceConfig[ability].increaseRate * (lvl - 1)),
        cost: mRound(aliceConfig[ability].initialCost * Math.pow(getMulti(currentChapter, aliceConfig[ability]), lvl - 1), 5)
    }
}

export const getUpgradeSpecBob = (ability: BobSkillName, lvl: number, currentChapter: number): { value: number, cost: number } => {
    return {
        value: 0,
        cost: 0
    }
}

// AFK reward
export const totalDamage = (durationMs: number, aura_dps: number): number => {
    return Math.floor(durationMs / 1000) * aura_dps;
}